



































































































import {
  computed,
  defineComponent,
  reactive,
  ref,
  watch,
} from '@vue/composition-api';
import { useMutation, useQuery, useResult } from '@vue/apollo-composable';

import useAuth from '@/useAuth';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonAreaCodeSelector from '@/components/Setting/CommonAreaCodeSelector.vue';
import CommonMultiCheckboxWithIcon from '@/components/CommonMultiCheckboxWithIcon.vue';
import getHubs from '@/gql/company/getHubs.gql';

import createDriverPayout from '@/gql/driverPayout/createDriverPayout.gql';
import updateDriverPayout from '@/gql/driverPayout/updateDriverPayout.gql';
import getDriverPayout from '@/gql/driverPayout/getDriverPayout.gql';
import useDriverProfile from '@/useDriverProfile';

const CommonFormWithDriverPayoutEditor = defineComponent({
  components: {
    CommonModalWithPreset,
    CommonAreaCodeSelector,
    CommonMultiCheckboxWithIcon,
  },
  props: {
    id: { type: [Number, String], default: -1 },
  },
  setup(props, { emit }) {
    const { me } = useAuth();
    const { transformToInteger, integerToArray } = useDriverProfile();
    const driverPayout = reactive({
      id: -1,
      code: '',
      area: null,
      name: '',
      vehicleType: [false, false, false, false],
      type: 'DRIVER',
      fine: 0,
      fee: 0,
      driverAllowance: 0,
      workDays: 1,
      hub: undefined,
      destinationHub: undefined,
    });

    const { result: driverPayoutResult, loading } = useQuery(getDriverPayout, computed(() => ({
      id: props.id,
    })));
    const _driverPayout = useResult(driverPayoutResult, {}, (data) => data.driverPayout);
    watch(() => driverPayoutResult.value, (newVal, oldVal) => {
      if (props.id !== -1 && !loading.value && newVal !== oldVal) {
        driverPayout.id = _driverPayout.value.id;
        driverPayout.code = _driverPayout.value.code;
        driverPayout.name = _driverPayout.value.name;
        driverPayout.vehicleType = integerToArray(_driverPayout.value.availableVehicleType);
        driverPayout.fine = _driverPayout.value.fine;
        driverPayout.fee = _driverPayout.value?.fee;
        driverPayout.driverAllowance = _driverPayout.value.driverAllowance;
        driverPayout.workDays = _driverPayout.value.workDays || 1;
        driverPayout.type = _driverPayout.value.type;
        driverPayout.area = _driverPayout.value.area;
        driverPayout.hub = _driverPayout.value.hub;
        driverPayout.destinationHub = _driverPayout.value.destinationHub;
      } else {
        driverPayout.id = -1;
        driverPayout.code = '';
        driverPayout.name = '';
        driverPayout.vehicleType = [false, false, false, false];
        driverPayout.fine = 0;
        driverPayout.fee = 0;
        driverPayout.driverAllowance = 0;
        driverPayout.workDays = 1;
        driverPayout.type = 'DRIVER';
        driverPayout.area = null;
        driverPayout.hub = undefined;
        driverPayout.destinationHub = undefined;
      }
    });

    const driverPayoutInput = computed(() => ({
      id: props.id === -1 ? undefined : props.id,
      code: driverPayout.code,
      name: driverPayout.name,
      availableVehicleType: transformToInteger(driverPayout.vehicleType),
      fine: driverPayout.fine,
      fee: driverPayout.fee,
      driverAllowance: driverPayout.driverAllowance,
      workDays: driverPayout.workDays,
      areaId: (driverPayout.area as any)?.id,
      type: driverPayout.type,
      hubId: driverPayout.hub ? parseInt((driverPayout.hub as any)?.id, 10) : undefined,
      hub: undefined,
      destinationHubId: driverPayout.destinationHub ? parseInt((driverPayout.destinationHub as any)?.id, 10) : undefined,
      destinationHub: undefined,
      createdBy: {
        connect: me.id,
      },
    }));

    const refetchQueryList = ['getDriverPayouts'];
    const createDriverPayoutMutation = useMutation(createDriverPayout, () => ({
      variables: {
        input: driverPayoutInput.value,
      },
      refetchQueries: refetchQueryList,
    }));
    const updateDriverPayoutMutation = useMutation(updateDriverPayout, () => ({
      variables: {
        input: {
          ...driverPayoutInput.value,
          createdBy: undefined,
        },
      },
      refetchQueries: refetchQueryList,
    }));

    const confirmModal = ref(null);
    createDriverPayoutMutation.onDone(() => {
      (confirmModal.value as any).compose({ action: 'บันทึก', entity: 'สำเร็จ' });
    });
    updateDriverPayoutMutation.onDone(() => {
      emit('done');
      (confirmModal.value as any).compose({ action: 'บันทึก', entity: 'สำเร็จ' });
    });
    const errorModal = ref(null);
    createDriverPayoutMutation.onError(() => {
      (errorModal.value as any).compose();
    });
    updateDriverPayoutMutation.onError(() => {
      emit('error');
      (errorModal.value as any).compose();
    });

    const computedMutation = computed(() => {
      if (props.id !== -1) return updateDriverPayoutMutation;
      return createDriverPayoutMutation;
    });

    return {
      getHubs,
      driverPayout,

      computedMutation,

      confirmModal,
      errorModal,
    };
  },
});

export default CommonFormWithDriverPayoutEditor;
